module.exports = __webpack_public_path__ + "assets/img/x.d998bccd.svg";